import { observer } from 'mobx-react';
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const PrivateRoute: React.FC<{}> = () => {

    if (localStorage.getItem('user')) {
        return <Outlet/>;
    } else {
        return <Navigate to={{ pathname: '/login' }} />
    }
};

export default observer(PrivateRoute);


// import { Navigate, Outlet, Route } from "react-router-dom";
// import authStore from "./store.js";
// import { observer } from "mobx-react-lite";

// const PrivateRoute = (props) => {

//   if (authStore.isLoadingAuth) {
//     return <div>Checking auth...</div>;
//   }
//   if (authStore.isAuth) {
//      return <Outlet/>
//   } else {
//     return <Navigate to="/login" />;
//   }
// };
  
// export default observer(PrivateRoute);